<template>
  <div>
    Dashboard
    <router-view></router-view>
  </div>
</template>

<script>




  export default {
    name: "KappDashboard",
    components: {
      // 'kapp-categories': KappCategoryNav,
      // 'kapp-header': Header,
      // 'kapp-subpage': SubPage
    },
    data() {
      return {
        categories: [],
        fullTextFilter: '',
        categoryFilter: '',
        listScrollable: true,
        categoriesVisible: true,
        animDirection: 'slide-left',
        hideArticleEffect: null
      };
    },
    props: [],
    methods: {}
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/KappDashboard.vue